export default __webpack_public_path__ + "static/media/arrow.8d9b8fc7.svg";